import { GraphBuilder } from '../graph/builder';
import { ComponentDef } from './types';

export const vitEncoderComponent: ComponentDef = {
  id: 'vit-encoder',
  name: 'ViT Encoder',
  description: 'Vision Transformer splits an image into patches and encodes them with self-attention.',
  category: 'multimodal',
  params: [
    { name: 'n_patches', label: 'Patches', type: 'number', default: 196, min: 1, max: 1024, step: 1 },
    { name: 'd_model', label: 'Model dimension', type: 'number', default: 768, min: 64, max: 4096, step: 64 }
  ],
  buildGraph: (params) => {
    const n_patches = Number(params.n_patches);
    const d_model = Number(params.d_model);

    const g = new GraphBuilder();
    g.input('image', [n_patches, d_model]);

    g.conv('patchify', 'image', [n_patches, d_model], 'patch');
    g.linear('cls', 'patchify', [d_model, d_model]);
    g.linear('q', 'cls', [d_model, d_model]);
    g.linear('k', 'cls', [d_model, d_model]);
    g.linear('v', 'cls', [d_model, d_model]);
    g.matmul('qk', 'q', 'k', [n_patches, n_patches]);
    g.softmax('attn', 'qk', -1);
    g.matmul('out', 'attn', 'v', [n_patches, d_model]);
    g.output('out', 'out');
    return g.build();
  }
};
